export default __webpack_public_path__ + "static/media/daphni-logo.2b45c897.png";